import { supabase } from "@/integrations/supabase/client";

const formatPayload = (label: string, payload?: Record<string, any>) => {
  const timestamp = new Date().toISOString();
  return `[AuthDebug][${timestamp}] ${label}${payload ? ` :: ${JSON.stringify(payload)}` : ""}`;
};

export const logAuthState = async (label: string) => {
  try {
    const { data, error } = await supabase.auth.getSession();
    if (error) {
      console.warn(formatPayload(label, { session: false, error: error.message }));
      return null;
    }

    const session = data.session;
    console.log(
      formatPayload(label, {
        session: !!session,
        user: session?.user?.email ?? null,
        expires_at: session?.expires_at ?? null,
      })
    );
    return session;
  } catch (err) {
    console.error(formatPayload(label, { session: false, error: (err as Error).message }));
    return null;
  }
};

export const logAuthEvent = (label: string, payload?: Record<string, any>) => {
  console.log(formatPayload(label, payload));
};
